<template>
   
    <div> 
        <div class="crumbs" style="margin-left:10px;" hidden="true">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 轮询管理
                </el-breadcrumb-item>
                 <el-breadcrumb-item>执行记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div> 
        <el-card shadow="hover" class="searchChooseCard" >
                <span class="label-span">
                    <label class="label">配置名称</label>  
                    <el-input v-model.trim="query.name" placeholder="配置名称" class="handle-input mr10"></el-input>   
                </span>
                <span class="label-span">
                    <label class="label">配置状态</label>     
                    <el-select v-model="query.taskStatus"  placeholder="配置状态"  clearable    @clear="resetSelect" class="handle-select mr15">
                        <el-option value="" label="全部"  />   
                        <el-option value="1" label="开启"  /> 
                        <el-option value="2,3" label="关闭"  />   
                    </el-select>  
                </span>
                <el-button type="success" icon="el-icon-search"  class="mr10"  @click="handleSearch">搜索</el-button>
                <el-button type="warning" icon="el-icon-refresh" class="mr10"   @click="refreshSearch">重置</el-button>
                <el-button type="primary" icon="el-icon-lx-roundadd" class="mr10"   @click="addBind" >添加配置</el-button> 
                 
               
        </el-card>
        <el-card shadow="hover"  class="containCard" >  
            <el-table :data="tableData" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <el-table-column prop="name" min-width="100" align="left" label="配置名称"></el-table-column> 
                <el-table-column prop="code" min-width="120" align="left" label="配置编码">  </el-table-column>  
                <el-table-column prop="descript" min-width="200" align="left" label="配置描述">
                   <template slot-scope="scope"> 
                        <span style='font-size:12px;'>{{scope.row.descript}}</span>
                    </template>  
                </el-table-column>  
                <el-table-column prop="apiUrl" min-width="180" align="left" label="接口地址">  </el-table-column>  
                <el-table-column prop="status" min-width="90" align="center" label="配置状态">
                    <template slot-scope="scope"> 
                        <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0"> 
                            </el-switch>
                    </template> 
                </el-table-column>   
                <el-table-column prop="createTime" min-width="160" align="center" label="创建时间"> </el-table-column> 
                <el-table-column label="操作" min-width="130" align="center"  fixed="right">
                    <template slot-scope="scope"> 
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column>   
            </el-table>
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 30, 100]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </el-card>
         
        <el-dialog :close-on-click-modal="false" title="添加配置" :modal-append-to-body='false' :visible.sync="addVisible"  width="580px">
             <el-form ref="form" :model="form1" label-width="80px">
                <el-form-item label="配置名称" >
                    <el-input  type="text" placeholder="配置名称"  v-model.trim="form1.name"></el-input>
                </el-form-item>
                <el-form-item label="配置编码" >
                    <el-input  type="text" placeholder="配置编码"  v-model.trim="form1.code"></el-input>
                </el-form-item>
                <el-form-item label="配置描述" >
                    <el-input  type="text" placeholder="配置描述"  v-model="form1.descript"></el-input>
                </el-form-item>
                <el-form-item label="接口地址" >
                    <el-input  type="text" placeholder="接口地址"  v-model.trim="form1.apiUrl"></el-input>
                </el-form-item>
            </el-form>
             <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="编辑配置" :modal-append-to-body='false' :visible.sync="editVisible"  width="580px">
             <el-form ref="form" :model="form2" label-width="80px">
                <el-form-item label="配置名称" >
                    <el-input  type="text" placeholder="配置名称"  v-model.trim="form2.name"></el-input>
                </el-form-item>
                <el-form-item label="配置编码" >
                    <el-input  type="text" placeholder="配置编码"  v-model.trim="form2.code"></el-input>
                </el-form-item>
                <el-form-item label="配置描述" >
                    <el-input  type="text" placeholder="配置描述"  v-model="form2.descript"></el-input>
                </el-form-item>
                <el-form-item label="接口地址" >
                    <el-input  type="text" placeholder="接口地址"  v-model.trim="form2.apiUrl"></el-input>
                </el-form-item>
            </el-form>
             <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
        
    </div>
</template>

<script>
import {fetchData,saveForm,changeForm, handDelete,changeStatus} from '../../../api/taskConfig';
 
export default {

    data() {
        return {    
            taskUse:false,
            mid:'',
            secret:'',
            stationId:'', 
            shopCode:'',
            loginName:'', 
            shopLink:'', 
            select:'',
            query: { 
                pageIndex: 1,
                pageSize: 10, 
            }, 
            tableData: [],
            tableData2:[],
            multipleSelection: [],
            delList: [], 
            editVisible:false,
            addVisible:false,
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {  
            },
            form2: {  
            },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    }, 
    //页面加载方法
    mounted: function () {  
        //查询列表
        this.getData();   
    },

    methods: {  
        
        // 编辑操作
        handleEdit(index, row) {       
            this.editVisible = true;
            this.form2 = row; 
        },
        // 触发搜索按钮

        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 保存更改
        saveEdit() {   
            this.editVisible = false;
            changeForm(this.form2).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.editVisible = true; 
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            var tips ; 
            if(row.status=='0'){ 
                row.status='1';
                tips = "禁用"; 
            }else{ 
                row.status = '0';
                tips = "启用"; 
            }
            // 二次确认删除
            this.$confirm("确认"+tips+"该配置吗？", '提示', {
                type: 'warning'
            }).then(() => { 
                if(row.status=='0'){ 
                    row.status='1' 
                }else{ 
                    row.status='0' 
                }
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        if(row.status=='0'){ 
                            row.status='1' 
                        }else{ 
                            row.status='0' 
                        }
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {});  
        },
 

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'name');  
            this.$set(this.query, 'status');   
            this.getData();  
        },   
         //刷新
        refresh(){
            history.go(0); 
        },
        //获取下拉框数据
        getSelect(){ 
            this.select = {};
            this.select.mid = this.mid;
            this.select.stationId = this.stationId;
            fetchSelect(this.select).then(res => {   
                if(res.code=='200'){ 
                    this.select.option = res.data; 
                }
            });
        },

        //查询
        getData(){
            // 获取列表数据  
            this.query.mid = this.mid;
            this.query.shopCode = this.shopCode;
            this.query.stationId = this.stationId; 
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal || 0;  
                }else{
                     this.tableData = null;
                    this.pageTotal = 0;  
                } 
            });
        },
 
        // 删除
        handDelete(index, row) {   
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功');  
                        this.getData();
                    }else{ 
                        this.$message.error(res.message); 
                    } 
                });
            }) 
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val; 
        },
        //批量删除
        delMore() {
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要删除的日志");
                return;
            } 
            let ids = ''; 
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                ids += this.multipleSelection[i].id + ','; 
            } 
            this.form.id = ids.substr(0,ids.length-1);  
            this.form.shopCode = this.shopCode;
            this.form.stationId = this.stationId;  
            handDeleteMore(this.form).then(res => {
                if(res.code=='200'){ 
                    this.changeFalse(); 
                    this.getData();
                    this.$message.success(res.message);  
                }else{
                    this.$message.error(res.message); 
                }
            }); 
        },

        //清空日志
        delAll(){
            this.form.shopCode = this.shopCode;
            this.form.stationId = this.stationId;  
            handDeleteAll(this.form).then(res => {
                if(res.code=='200'){ 
                    this.changeFalse(); 
                    this.getData();
                    this.$message.success(res.message);  
                }else{
                    this.$message.error(res.message); 
                }
            }); 
        },
        //取消更改等级
        changeFalse(){ 
            //清空多选值
            this.multipleSelection = [];
            //多选框反选
            this.$refs.multipleTable.clearSelection();
        },

        // 启动轮询
        taskStart() {  
            this.taskUse = true; 
            this.$message.success("开始轮询...");
            task().then(res => {  
                this.$message.success("轮询结束！");
                this.taskUse = false;
                this.getData(); 
            });   
        },

        // 失败轮询
        taskError() {  
            this.taskUse = true; 
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要轮训的日志");
                return;
            } 
            let ids = ''; 
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                ids += this.multipleSelection[i].id + ','; 
            } 
            this.form.id = ids.substr(0,ids.length-1); 
            
            this.form.stationId = this.stationId;   
            this.$message.success("开始轮询...");
            taskSelect(this.form).then(res => {   
                this.$set(this.query, 'taskStatus'); 
                this.$set(this.query, 'taskInfo'); 
                this.$set(this.query, 'id',this.form.id); 
                this.$message.success("轮询结束！");
                this.taskUse = false;
                this.getData(); 
            });   
        }, 
        addBind(){
            this.addVisible = true;
        },
        //保存新增
        saveForm() {   
            if( !this.form1.name ){
                this.$message.error("请填写配置名称");
                return;
            } 
            if( !this.form1.code ){
                this.$message.error("请填写配置编码");
                return;
            }   
            this.addVisible = false; 
            saveForm(this.form1).then(res => { 
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                } 
            });
        }, 
        //复制链接
         copyLink(index,row){ 
            var inputElement =  document.getElementById("copyLink");  
            inputElement.value=this.shopLink+"&af="+row.id;
            inputElement.select();
            // 执行浏览器复制命令
            document.execCommand("Copy");
            //提示已复制
            this.$message.success("已复制成功，快去分享吧");
           
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData(this.query);
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData(this.query);
        }
    }
};
</script>

<style>
.ql-container{
    min-height:250px; 
  }
.ql-editor{
	height: 250px;
}
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 120px;
    display: inline-block;
}

.handle-input {
    width: 180px;
    display: inline-block;
} 
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
